import { mutatorAction } from 'satcheljs';
import { getUnreadSearchFolderStore } from '../store/unreadSearchFolderStore';

export const setSearchFolderUnreadRestrictionsMutator: (
    hasUnreadRestrictionByFolderId: Record<string, boolean>
) => void = mutatorAction(
    'setSearchFolderUnreadRestrictions',
    (hasUnreadRestrictionByFolderId: Record<string, boolean>) => {
        Object.assign(
            getUnreadSearchFolderStore().searchFolderHasUnreadRestriction,
            hasUnreadRestrictionByFolderId
        );
    }
);
